<template>
  <div id="result">
    <!-- 已结束 -->
    <div class="vx-row">
      <div class="vx-col w-full  mb-base">
        <vx-card v-if="match.matchResult"
            slot="no-body"
            class="text-center bg-primary-gradient greet-user"
          >
          <img
            :src="require('@/assets/images/elements/decore-left.png')"
            class="decore-left"
            alt="Decore Left"
            width="200"
          />
          <img
            :src="require('@/assets/images/elements/decore-right.png')"
            class="decore-right"
            alt="Decore Right"
            width="175"
          />
          <feather-icon
            icon="AwardIcon"
            class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
          <h1 class="mb-6 text-white">恭喜你{{ match.type === 0 ? '的团队':'' }}“{{ match.teamName }}”在该比赛中获得 <i>{{ match.matchResult }}</i> 的好成绩！</h1>
          <p class="text-white mt-5">Congratulations !</p>
        </vx-card>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>